import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH Product Geoblock Groups ********************
export const fetchProductGeoblockGroupsItem = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_PRODUCT_GEOBLOCK_GROUPS_LOADING,
			payload: true
		});

		const { data } = await services.get(`/geoblocking/product/${id}/groupList`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_PRODUCT_GEOBLOCK_GROUPS_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_PRODUCT_GEOBLOCK_GROUPS_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
